import { render, staticRenderFns } from "./ExcludedInfo.vue?vue&type=template&id=64dea97e&scoped=true&"
import script from "./ExcludedInfo.vue?vue&type=script&lang=js&"
export * from "./ExcludedInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dea97e",
  null
  
)

export default component.exports